'use client'
import React, { useEffect } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogTitle,
} from '@paladise/ui/components/ui/alert-dialog'
import { useTranslations } from 'next-intl'
import { useSendTracker } from '@paladise/tracker/hooks/useSendTracker'
import { TRACKER_EVENTS } from '@paladise/tracker/constants/event'

interface Prop {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}

const EUConsentModal = ({ isOpen, onOpenChange }: Prop) => {
  const t = useTranslations()
  const { handleEventTracker } = useSendTracker()
  const items = [
    t('subscription_consent_item_1'),
    t('subscription_consent_item_2'),
  ]

  useEffect(() => {
    if (!isOpen) return
    handleEventTracker({
      eventName: TRACKER_EVENTS.popup_subscriptionconsent_show,
    })
  }, [])

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent
        position={'bottom'}
        className={'w-full px-6 pb-[34px] pt-4'}
        aria-describedby={undefined}
      >
        <AlertDialogTitle className="text-header text-left">
          {t('subscription_consent_title')}
        </AlertDialogTitle>
        <ul className={`mb-6 list-disc pl-4`}>
          {items.map(item => (
            <li key={item} className="text-body text-label-l2 mb-1">
              {item}
            </li>
          ))}
        </ul>

        <AlertDialogFooter>
          <AlertDialogAction
            variant={'primary'}
            className={'text-callout mb-2 w-full p-[15px]'}
          >
            {t('common.agree')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default EUConsentModal
